import { Injectable, inject } from '@angular/core';
import { Observable, map, catchError, of } from 'rxjs';
import { AiEntitlementRestApi } from '../../../infrastructure/api/ai-entitlement-rest.api';
import { GetAiEntitlementResult } from './get-ai-entitlement.result';

/**
 * Get AI Entitlement use case.
 * Retrieves the AI entitlement configuration for the current tenant.
 */
@Injectable({ providedIn: 'root' })
export class GetAiEntitlementUseCase {
  private readonly _api = inject(AiEntitlementRestApi);

  public execute(): Observable<GetAiEntitlementResult> {
    return this._api.getAiEntitlement().pipe(
      map((data) => ({ success: true, data })),
      catchError((error: { message?: string }) => of({ success: false, error: error.message })),
    );
  }
}
